import { render } from "./BookingDetails.vue?vue&type=template&id=2f99ea2b&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"

import "./BookingDetails.vue?vue&type=style&index=0&id=2f99ea2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f99ea2b"]])

export default __exports__